/* eslint-disable react/jsx-props-no-spreading, max-len */
import Icon from '../components/Icon'
import categories from './categories'

function PencilSquare(props) {
  return (
    <Icon {...props}>
      <path d="M19,19 L5,19 L5,5 L12,5 L12,3 L5,3 C3.89,3 3,3.9 3,5 L3,19 C3,20.1 3.89,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,12 L19,12 L19,19 Z" />
      <polygon points="12.7112971 14 10 14 10 11.2887029 16.3075314 5 19 7.69246861" />
      <path d="M20.800222,5.75693674 L19.5571587,7 L17,4.44284129 L18.2430633,3.19977802 C18.509434,2.93340733 18.9356271,2.93340733 19.2019978,3.19977802 L20.800222,4.79800222 C21.0665927,5.06437292 21.0665927,5.49056605 20.800222,5.75693674 L20.800222,5.75693674 Z" />
    </Icon>
  )
}

PencilSquare.tags = ['Compose', 'New']
PencilSquare.category = categories.actions

export default PencilSquare
